import { HrAttendance } from "../types/HrTypes";

/** How attendance was set: punch machine, remote/self portal mark, or manager portal edit. */
export function attendanceMarkedHow(row?: HrAttendance | null): {
  label: string;
  by?: string;
} {
  if (!row) return { label: "—" };
  const source = String(row.source || "").toLowerCase();
  const by = String(row.marked_by || "").trim();
  const notes = String(row.notes || "").toLowerCase();
  const hasPunch =
    Boolean(row.punch_in_at) || Number(row.punch_count || 0) > 0;

  if (by === "auto-week-off" || by === "sql-week-off") {
    return { label: "Auto week off" };
  }
  if (by === "auto-unpaid") return { label: "Auto unpaid" };

  if (
    notes.includes("marked online (remote)") ||
    (String(row.status).toLowerCase() === "wfh" && source === "manual")
  ) {
    return { label: "Self (remote)", by: by || undefined };
  }
  if (
    notes.includes("marked online (hybrid)") ||
    notes.includes("marked online (super admin)")
  ) {
    return { label: "Self (portal)", by: by || undefined };
  }

  if (
    source === "live_api" ||
    source === "shift_auto" ||
    (hasPunch && source !== "hr_manual")
  ) {
    return { label: "Punch in" };
  }

  if (source === "hr_manual" || source === "manual") {
    return { label: "Portal", by: by || undefined };
  }

  if (hasPunch) return { label: "Punch in" };
  if (by) return { label: "Portal", by };
  return { label: "—" };
}
